<template>
    <div id="c_modal" class="card-container">
        <a-modal
            :title="title"
            :visible="visible"
            :mask="mask"
            :okText="okText"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <slot></slot>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '标题'
        },
        visible: {
            type: Boolean,
            default: false
        },
        mask: {
            type: Boolean,
            default: true
        },
        okText: {
            type: String,
            default: '确认'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        backFunctionName: {
            type: String,
            default: ''
        },
        backFunctionData: {
            type: Boolean,
            default: false
        },
        subName: {
            type: Object,
            default: function () {
                return {
                    // Modal是否关闭下标名称
                    modalName: '',
                    // Modal下Slot数据下标名称
                    slotDataName: '',
                    // Modal下Slot数据恢复初始预设
                    clearDataName: []
                }
            }
        },
    },
    data() {
        return {
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    methods: {
        // 确定按钮
        handleOk(e) {
            const backData = {
                status: true,
                dataName: this.backFunctionData ? this.subName : {}
            }
            this.$emit(this.backFunctionName, this.backFunctionData ? backData : '');
        },
        // 取消按钮
        handleCancel(e) {
            const backData = {
                status: false,
                dataName: this.backFunctionData ? this.subName : {}
            }
            this.$emit(this.backFunctionName, this.backFunctionData ? backData : '');
        },
    }
};
</script>
